import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que comprar juguetes caros?',
    a: 'No, te enseñamos a usar lo que ya tenés en casa.'
  }, {
    q: '¿Sirve para perros adultos?',
    a: 'Sí, el olfato es una necesidad básica a cualquier edad.'
  }, {
    q: '¿Es un solo pago?',
    a: 'Sí, pagás una vez y tenés acceso de por vida a la guía y sus actualizaciones.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-20 px-5 sm:px-8 bg-white" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <FadeIn data-id="element-32">
          <h2 className="text-2xl sm:text-4xl text-depto-brown mb-8 sm:mb-12 text-center" data-id="element-33">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-34">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-35">
              <div className="border border-depto-brown/10 rounded-2xl overflow-hidden" data-id="element-36">
                <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-depto-beige/30 transition-colors" data-id="element-37">
                  <span className="font-bold text-depto-brown text-lg pr-4" data-id="element-38">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-depto-amber transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-39" />
                </button>
                <AnimatePresence data-id="element-40">
                  {openIndex === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-41">
                      <div className="p-6 pt-0 text-depto-brown/80 text-lg border-t border-depto-brown/5" data-id="element-42">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}